import nwApi from '../nwApi'

export default function (param) {
    param.params.target="/base/service/weChat"
    console.log(JSON.stringify(param))
    nwApi.common('NutService',param)
}